import { ToggleButton, ToggleButtonGroup, Stack } from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';

const B = { primary: '#4357AD' };

const SORT_OPTIONS = [
  { value: 'newest', label: 'Найновіші' },
  { value: 'oldest', label: 'Найстаріші' },
  { value: 'highest', label: 'Найвища оцінка' },
  { value: 'lowest', label: 'Найнижча оцінка' },
];

const ReviewSortControls = ({ value, onChange }) => (
  <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
    <SortIcon sx={{ fontSize: 16, color: '#8891A5' }} />
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, val) => { if (val) onChange(val); }}
      size="small"
      sx={{
        flexWrap: 'wrap', gap: 0.5,
        '& .MuiToggleButton-root': {
          border: '1px solid #EDE9FE', borderRadius: '16px !important', px: 1.5, py: 0.25,
          textTransform: 'none', fontSize: 11, fontWeight: 600, color: '#8891A5',
          '&.Mui-selected': { bgcolor: B.primary, color: '#fff', borderColor: B.primary, '&:hover': { bgcolor: '#3648A0' } },
        },
      }}
    >
      {SORT_OPTIONS.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value}>{opt.label}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Stack>
);

export default ReviewSortControls;
